import React from 'react';
import './CookiesPopup.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import Button from 'Components/Shared/Button/Button';

interface IProps {
  content: Julius.Website.CookiesNotificationViewModel;
  onRequiredOK: () => void;
  onAllOK: () => void;
}

const CookiesPopup: React.SFC<IProps> = ({
  content: {
    title,
    text,
  },
  onAllOK,
  onRequiredOK,
}) => (
  <div className='cookies-popup'>
    <div className='left'>
      <div className='cookies-title'>{ title }</div>
      <div className='cookies-button'>
        <Button onClick={ onRequiredOK } color='black'>
          <FormattedText
            displayName='Endast nödvändiga'
            formattedName='cookies.agreeRequired'
          />
        </Button>
      </div>
      <div className='cookies-button'>
        <Button onClick={ onAllOK } color='purple'>
          <FormattedText
            displayName='Godkänn'
            formattedName='cookies.agreeAll'
          />
        </Button>
      </div>
    </div>
    <div className='cookies-text' dangerouslySetInnerHTML={ { __html: text } } />
  </div>
);

export default CookiesPopup;


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/CookiesPopup.tsx